export default __webpack_public_path__ + "static/media/preview-video-2.e12fd731.jpg";